function OperatingResults2024() {
	return (
		<div className="not-prose">
			<div className="overflow-x-auto">
				<table className="min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<thead>
						<tr className="text-center no-hover text-[#4B7B9D] leading-[140%] ">
							<td></td>
							<th colSpan={3} className="align-bottom border-none">
								Peronal Lines
								<br />
								Business
							</th>
							<th className="align-bottom border-none">
								<span className="block mb-2 text-right text-[0.75rem] text-black">($ in billions)</span>
								Commercial Lines Business
							</th>
						</tr>
						<tr className="text-right no-hover text-[#4B7B9D]">
							<td></td>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Vehicles</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Property</th>
							<th className="border-t-[1px] border-t-[#BFBFBF]">Total</th>
							<td className="border-t-[1px] border-t-[#BFBFBF]"></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Written</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>
								<span className="float-left">$</span>60.4
							</td>
							<td>
								<span className="float-left">$</span>3.1
							</td>
							<td>
								<span className="float-left">$</span>63.5
							</td>
							<td>
								<span className="float-left">$</span>10.9
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2023</td>
							<td>48.6</td>
							<td>2.8</td>
							<td>51.4</td>
							<td>10.1</td>
						</tr>
						<tr>
							<td className="cell-indent">Growth over prior year</td>
							<td>24%</td>
							<td>8%</td>
							<td>23%</td>
							<td>8%</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Net Premiums Earned</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>
								<span className="float-left">$</span>57.1
							</td>
							<td>
								<span className="float-left">$</span>3.0
							</td>
							<td>
								<span className="float-left">$</span>60.1
							</td>
							<td>
								<span className="float-left">$</span>10.7
							</td>
						</tr>
						<tr>
							<td className="cell-indent">2023</td>
							<td>46.2</td>
							<td>2.6</td>
							<td>48.8</td>
							<td>9.9</td>
						</tr>
						<tr>
							<td className="cell-indent">Growth over prior year</td>
							<td>24%</td>
							<td>17%</td>
							<td>23%</td>
							<td>8%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Policies in Force</td>
							<td></td>
							<td></td>
							<td></td>
							<td className="text-[0.75rem] font-trade">(# in thousands)</td>
						</tr>
						<tr>
							<td className="cell-indent">2024</td>
							<td>30,294</td>
							<td>3,517</td>
							<td>33,811</td>
							<td>1,141</td>
						</tr>
						<tr>
							<td className="cell-indent">2023</td>
							<td>25,495</td>
							<td>3,096</td>
							<td>28,591</td>
							<td>1,099</td>
						</tr>
						<tr>
							<td className="cell-indent">Growth over prior year</td>
							<td>19%</td>
							<td>14%</td>
							<td>18%</td>
							<td>4%</td>
						</tr>
					</tbody>
				</table>

				<table className="my-12 min-w-full tabular-nums border-collapse table-auto is-financial-table is-financial-table--operations">
					<tbody>
						<tr>
							<td className="font-bold font-trade text-[#767727] no-hover">Underwriting Ratios</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td className="cell-indent">Loss and loss adjustment expense ratio</td>
							<td>68.9</td>
							<td>70.1</td>
						</tr>
						<tr>
							<td className="cell-indent">Underwriting expense ratio</td>
							<td className="border-b-[1px] border-[#BFBFBF]">19.7</td>
							<td className="border-b-[1px] border-[#BFBFBF]">19.3</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2024</td>
							<td>88.6</td>
							<td>89.4</td>
						</tr>
						<tr>
							<td className="cell-indent--2">Combined ratio – 2023</td>
							<td>94.1 </td>
							<td>98.8</td>
						</tr>
					</tbody>
					<tr>
						<td className="cell-indent">Change over prior year </td>
						<td>(5.5) pts. </td>
						<td>(9.4) pts.</td>
					</tr>
				</table>
			</div>
		</div>
	);
}

export default OperatingResults2024;
